const TRAPDOOR_TEXT_ITEM_MAX_WIDTH = 316;
export { TRAPDOOR_TEXT_ITEM_MAX_WIDTH };
//# sourceMappingURL=constants.js.map
